import { render, staticRenderFns } from "./itemAttentionTable.vue?vue&type=template&id=03b6df2e"
import script from "./itemAttentionTable.vue?vue&type=script&lang=js"
export * from "./itemAttentionTable.vue?vue&type=script&lang=js"
import style0 from "./itemAttentionTable.vue?vue&type=style&index=0&id=03b6df2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports